<template>
  <van-list class="list" finished-text="没有更多了">
    <van-cell v-for="(item, index) in cardData" :key="index">
      <div class="card" @click="onClick(item)">
        <swiperThree class="card-img" :data="item.image" />
        <div class="desc">
          <h4 class="title">{{ item.title }}</h4>
          <ul v-if="item.keyword" class="tag">
            <li
              v-for="(tag, tagIndex) in tagArray(item.keyword)"
              :key="tagIndex"
            >
              {{ tag }}
            </li>
          </ul>
          <div v-if="item.address && item.money" class="address">
            <div class="left">
              <van-icon name="guide-o" />{{ item.address }}
            </div>
            <p><span>¥</span>{{ item.money }}<b>起</b></p>
          </div>
        </div>
      </div>
    </van-cell>
  </van-list>
</template>

<script>
import swiperThree from "@/components/CustomSwiper/swiper3.vue";
export default {
  name: "CardOne",
  components: {
    swiperThree,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      screenWidth: null,
      spanCol: 0,
    };
  },
  computed: {
    cardData() {
      return this.data;
    },
  },

  watch: {
    screenWidth: {
      handler: function (val) {
        if (val > 1200) {
          this.spanCol = 6;
        } else if (val > 800) {
          this.spanCol = 12;
        } else {
          this.spanCol = 24;
        }
      },
      immediate: true,
      deep: true,
    },
  },

  mounted() {
    this.screenWidth = document.body.clientWidth;
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })();
    };
  },
  methods: {
    tagArray(value) {
      return value.split(",");
    },
    onClick(item) {
      this.$router.push({
        path: "/detail",
        query: {
          id: item.id,
          type: item.type,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>

.list{
  box-sizing: border-box;
  height: calc(100% - 96px);
  max-width: 800px;
  margin: auto;
  overflow: auto;
}
.card {
  margin: 5px 16px;
  box-shadow: 0 2px 5px 0 rgb(50 50 50 / 15%);
  overflow: hidden;
  border-radius: 8px;
  box-sizing: border-box;
  position: relative;

  .card-img{
    max-height: 300px;
  }
  .poa {
    color: #fff;
    position: absolute;
    right: 10px;
    bottom: 10px;
    border-bottom: 3px #bc4853 solid;
  }
  .desc {
    padding: 5px 10px;
    .title {
      color: #bc4853;
    }
    .tag {
      margin-top: 5px;
      display: flex;
      align-items: center;
      li {
        border-width: 1px;
        border-style: solid;
        color: #0bcfca;
        padding: 0 8px;
        border-radius: 4px;
        font-size: 10px;
        .grade {
          color: orange;
        }
        &:not(:first-child) {
          margin-left: 10px;
        }
      }
    }
    .address {
      margin-top: 5px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .left {
        display: flex;
        align-items: center;
        color: #999;
        font-size: 10px;
      }

      p {
        font-size: 20px;
        color: #ffbb40;
        span {
          font-size: 10px;
        }
        b {
          font-size: 10px;
          color: #999;
        }
      }
    }
  }
}

img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
